/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The GetUploadStatusRequest model module.
* @module model/GetUploadStatusRequest
* @version 2020-12-7
*/
export default class GetUploadStatusRequest {
    /**
    * Constructs a new <code>GetUploadStatusRequest</code>.
    * @alias module:model/GetUploadStatusRequest
    * @class
    * @param uploadStatusId {Number} アップロードの現状ID
    */

    constructor(uploadStatusId) {
        
        
        this['uploadStatusId'] = uploadStatusId;
        
    }

    /**
    * Constructs a <code>GetUploadStatusRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetUploadStatusRequest} obj Optional instance to populate.
    * @return {module:model/GetUploadStatusRequest} The populated <code>GetUploadStatusRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetUploadStatusRequest();
                        
            
            if (data.hasOwnProperty('uploadStatusId')) {
                obj['uploadStatusId'] = ApiClient.convertToType(data['uploadStatusId'], 'Number');
            }
        }
        return obj;
    }

    /**
    * アップロードの現状ID
    * @member {Number} uploadStatusId
    */
    'uploadStatusId' = undefined;




}
